import { Map, List, fromJS } from 'immutable'

export function interviewStatus(state = Map(), action) {
  if (action.type === 'INTERVIEW_STATUS_OPEN') return state.setIn([action.interview_id, 'open'], true)

  if (action.type === 'INTERVIEW_STATUS_CLOSE') return state.setIn([action.interview_id, 'open'], false)

  if (action.type === 'INTERVIEW_STATUS_LOADING') return state.setIn([action.interview_id, 'loading'], true)

  if (action.type === 'INTERVIEW_STATUS_SUCCESS')
    return state.setIn([action.interview_id, 'open'], false).setIn([action.interview_id, 'loading'], false)

  if (action.type === 'INTERVIEW_STATUS_ERROR')
    return state.setIn([action.interview_id, 'error'], action.message).setIn([action.interview_id, 'loading'], false)

  return state
}
